import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

function NotFound() {
  return (
    <>
      <Helmet>
        <title>გვერდი ვერ მოიძებნა – GSPEN</title>
        <meta
          name="description"
          content="გთხოვთ დაბრუნდეთ მთავარი გვერდზე ან სცადოთ სხვა ბმული."
        />
        <meta name="robots" content="noindex,follow" />
      </Helmet>

      <div className="flex flex-col items-center justify-center py-16">
        <h1 className="text-3xl font-bold mb-4">404 – გვერდი ვერ მოიძებნა</h1>
        <p className="mb-6 text-center max-w-md">
          ბმული, რომელსაც ეძებ, არ არსებობს ან გადატანილია.
        </p>
        <Link
          to="/"
          className="px-4 py-2 rounded-md bg-[#123257] text-white hover:bg-blue-700 transition"
        >
          დაბრუნება მთავარ გვერდზე
        </Link>
      </div>
    </>
  );
}

export default NotFound;
